/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coral_Soft_Bee_WaveInputs */

const en_coral_soft_bee_wave = /** @type {(inputs: Coral_Soft_Bee_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selects which engine serves this template's results. Analytics is the new result-set system; Legacy is the previous one. Result shapes are identical.`)
};

const de_coral_soft_bee_wave = /** @type {(inputs: Coral_Soft_Bee_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legt fest, welche Engine die Ergebnisse dieser Vorlage liefert. „Analytics“ ist das neue Ergebnis-System, „Legacy“ das bisherige. Die Ergebnisstruktur ist identisch.`)
};

/**
* | output |
* | --- |
* | "Selects which engine serves this template's results. Analytics is the new result-set system; Legacy is the previous one. Result shapes are identical." |
*
* @param {Coral_Soft_Bee_WaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coral_soft_bee_wave = /** @type {((inputs?: Coral_Soft_Bee_WaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coral_Soft_Bee_WaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coral_soft_bee_wave(inputs)
	return de_coral_soft_bee_wave(inputs)
});